import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) =>
  state.quoteInformation || initialState;

export const selectQuoteInformation = createSelector(
  [selectSlice],
  state => state,
);
